import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Heart, Check } from 'lucide-react';
const coreServices = [{
  title: 'Swedish Massage',
  duration: '60 minutes',
  price: '$90'
}, {
  title: 'Swedish Massage',
  duration: '90 minutes',
  price: '$130'
}, {
  title: 'Deep Tissue',
  duration: '60 minutes',
  price: '$110'
}, {
  title: 'Hot Stone',
  duration: '60 minutes',
  price: '$105'
}, {
  title: 'Aromatherapy',
  duration: '60 minutes',
  price: '$105'
}];
const couplesServices = [{
  title: 'Couples Massage',
  duration: '60 minutes',
  price: '$200',
  description: 'A shared massage experience side by side in our private suite.'
}, {
  title: 'VIP Couples Package',
  duration: 'Full experience',
  price: '$300',
  featured: true,
  description: 'The complete indulgence — relaxation, intimacy, and a little celebration.',
  includes: ['60-minute massage', '35-minute jacuzzi', 'Champagne & fruit', '420-friendly on request']
}];
const fadeUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  }
};
export function Services() {
  return <section id="services" className="py-24 md:py-32 relative" data-id="element-316">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-plum-900/40 to-transparent pointer-events-none" data-id="element-317"></div>

      <div id="pricing" className="max-w-6xl mx-auto px-6 md:px-12 relative" data-id="element-318">
        {/* Header */}
        <div className="text-center mb-20" data-id="element-319">
          <motion.span {...fadeUp} className="text-rose-400 uppercase tracking-[0.2em] text-sm mb-4 block" data-id="element-320">
            Afriel Spa
          </motion.span>
          <motion.h2 {...fadeUp} transition={{
          delay: 0.1
        }} className="font-serif text-4xl md:text-6xl text-lavender-50 mb-4" data-id="element-321">
            Massage{' '}
            <span className="italic bg-gradient-to-r from-lavender-300 to-rose-400 bg-clip-text text-transparent" data-id="element-322">
              Menu
            </span>
          </motion.h2>
          <p className="text-lavender-100/60 font-light max-w-xl mx-auto" data-id="element-323">
            Soothing, thoughtfully curated massage experiences.
          </p>
        </div>

        {/* Core Services */}
        <div className="mb-24" data-id="element-324">
          <motion.div {...fadeUp} className="flex items-center gap-4 mb-10" data-id="element-325">
            <Sparkles className="text-lavender-300" size={20} strokeWidth={1.2} data-id="element-326" />
            <h3 className="font-serif text-2xl md:text-3xl text-lavender-50" data-id="element-327">
              Core Services
            </h3>
            <div className="flex-1 h-[1px] bg-gradient-to-r from-lavender-400/30 to-transparent" data-id="element-328"></div>
          </motion.div>

          <div className="bg-plum-900/30 border border-lavender-400/10 rounded-2xl overflow-hidden" data-id="element-329">
            {coreServices.map((service, index) => <motion.div key={`${service.title}-${service.duration}`} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className={`flex items-baseline justify-between gap-4 px-6 md:px-8 py-5 hover:bg-plum-900/50 transition-colors ${index !== coreServices.length - 1 ? 'border-b border-lavender-400/10' : ''}`} data-id="element-330">
                <div className="flex-1 flex flex-wrap items-baseline gap-x-3" data-id="element-331">
                  <span className="font-serif text-lg md:text-xl text-lavender-50" data-id="element-332">
                    {service.title}
                  </span>
                  <span className="text-xs uppercase tracking-widest text-lavender-200/50" data-id="element-333">
                    {service.duration}
                  </span>
                </div>
                <span className="font-sans font-semibold text-xl md:text-2xl text-rose-300 tabular-nums whitespace-nowrap" data-id="element-334">
                  {service.price}
                </span>
              </motion.div>)}
          </div>
        </div>

        {/* Couples Experiences */}
        <div className="mb-24" data-id="element-335">
          <motion.div {...fadeUp} className="flex items-center gap-4 mb-10" data-id="element-336">
            <Heart className="text-rose-400" size={20} strokeWidth={1.2} data-id="element-337" />
            <h3 className="font-serif text-2xl md:text-3xl text-lavender-50" data-id="element-338">
              Couples Experiences
            </h3>
            <div className="flex-1 h-[1px] bg-gradient-to-r from-rose-400/30 to-transparent" data-id="element-339"></div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-340">
            {couplesServices.map((service, index) => <motion.div key={service.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className={`relative p-8 rounded-2xl border transition-all duration-500 ${service.featured ? 'bg-gradient-to-br from-lavender-500/20 to-rose-500/10 border-lavender-400/40 hover:border-lavender-300/70' : 'bg-plum-900/40 border-lavender-400/10 hover:border-lavender-400/40'}`} data-id="element-341">
                {service.featured && <div className="absolute -top-3 left-8 px-3 py-1 bg-gradient-to-r from-lavender-500 to-rose-500 text-white text-[10px] uppercase tracking-widest rounded-full" data-id="element-342">
                    VIP
                  </div>}

                <div className="flex justify-between items-baseline mb-3" data-id="element-343">
                  <h4 className="font-serif text-2xl text-lavender-50" data-id="element-344">
                    {service.title}
                  </h4>
                  <span className="font-sans font-semibold text-2xl md:text-3xl text-rose-300 tabular-nums whitespace-nowrap" data-id="element-345">
                    {service.price}
                  </span>
                </div>
                <span className="text-xs uppercase tracking-widest text-lavender-200/50 block mb-4" data-id="element-346">
                  {service.duration}
                </span>
                <p className="text-lavender-100/70 font-light leading-relaxed text-sm mb-6" data-id="element-347">
                  {service.description}
                </p>

                {service.includes && <div className="pt-5 border-t border-lavender-400/15" data-id="element-348">
                    <span className="text-[11px] uppercase tracking-[0.2em] text-lavender-200/60 block mb-3" data-id="element-349">
                      Includes
                    </span>
                    <ul className="space-y-2" data-id="element-350">
                      {service.includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-lavender-100/80 font-light" data-id="element-351">
                          <Check size={14} strokeWidth={1.5} className="text-rose-300 mt-1 flex-shrink-0" data-id="element-352" />
                          <span data-id="element-353">{item}</span>
                        </li>)}
                    </ul>
                  </div>}
              </motion.div>)}
          </div>
        </div>

        {/* Closing quote */}
        <motion.div {...fadeUp} transition={{
        delay: 0.2
      }} className="text-center pt-8" data-id="element-354">
          <p className="font-serif italic text-2xl md:text-3xl bg-gradient-to-r from-lavender-300 via-rose-300 to-lavender-300 bg-clip-text text-transparent" data-id="element-355">
            "Relaxation is in the details."
          </p>
        </motion.div>
      </div>
    </section>;
}